/* globals $ */
(function() {
    'use strict';

    window.LionSort = function(tableIdentifier, disabledColumns, sortOnElement) {

        if (!sortOnElement) {
            sortOnElement = 'tbody > tr';
        }

        var sortTable = function(columnName, isAsc) {

            $(tableIdentifier + ' > ' + sortOnElement).sort(function(a, b) {

                if (!isAsc) {
                    var tmp = b;
                    b = a;
                    a = tmp;
                }

                var firstAttr = $(a).attr('data-' + columnName);
                if (isNaN(parseInt(firstAttr))) {
                    return $(a).attr('data-' + columnName).localeCompare($(b).attr('data-' + columnName));
                } else {
                    return parseInt($(a).attr('data-' + columnName)) - parseInt($(b).attr('data-' + columnName));
                }

            }).appendTo($(tableIdentifier));

        };

        $(tableIdentifier + ' > thead > tr > th').click(function() {
            var colSort = $(this).attr('rel');
            if (!colSort || disabledColumns.indexOf(colSort) >= 0) {
                return false;
            }

            if ($(this).hasClass('asc-sorted')) {
                $(this).removeClass('asc-sorted');
                $(this).addClass('desc-sorted');
                $(this).find('.fa').attr('class', 'fa fa-caret-up');
                sortTable(colSort, false);
            }
            else if ($(this).hasClass('desc-sorted')) {
                $(this).removeClass('desc-sorted');
                $(this).addClass('asc-sorted');
                $(this).find('.fa').attr('class', 'fa fa-caret-down');
                sortTable(colSort, true);
            }
            else {
                $(tableIdentifier + ' > thead > tr > th').removeClass('asc-sorted');
                $(tableIdentifier + ' > thead > tr > th').removeClass('desc-sorted');
                $(tableIdentifier + ' > thead > tr > th .fa').attr('class', 'fa fa-sort');
                $(this).addClass('asc-sorted');
                $(this).find('.fa').attr('class', 'fa fa-caret-down');
                sortTable(colSort, true);
            }
            return false;
        });

        return {
            sort: function(column, isAsc) {
                sortTable(column, isAsc);
            }
        };

    };
})();